import React, { useState, useEffect, useContext, useCallback } from 'react';
import { Form, Select, Input, Checkbox, Button } from 'antd';
import { MaskedInput } from "antd-mask-input";
import { ReactComponent as ArrowDownSvg } from '../../../assets/icons/greenArrowDown.svg';
import { usePersonalDataModal, PersonalDataModal } from '../../../components/shared/PersonalData';
import { createJobApplication, getProfessionsList } from '../../../api/api';
import { makeFormData } from '../../../utils/helpers/request';
import FormFinishModal from '../FormFinishModal/FormFinishModal';
import { RestaurantContext } from '../../../providers/restaurant';
import useResizeWindows from '../../../utils/hooks/useResizeWindow';
import { itemRules } from '../../../utils/helpers/constants';
import { getDistance, getMarginInlineStart } from '../../../utils/helpers/functions';
import { getCitiesOptions } from '../../../utils/restaurant';
import './JobApplicationForm.scss';




const JobApplicationForm = () => {
  const { Item } = Form;
  const { TextArea } = Input;
  const width = useResizeWindows();
  const { places, current } = useContext(RestaurantContext);
  const { personalDataModal, open, close, } = usePersonalDataModal();
  let citiesOptions = getCitiesOptions(places);
  const [profOpts, setProfOpts] = useState([]);
  const [applicationState, setApplicationState] = useState({
    showingModal: false,
    inputState: {},
  })

  const formConfig = {
    "last_name": "Фамилия",
    "first_name": "Имя",
    "middle_name": "Отчество",
    "phone": "Телефон",
    // "rest_id": "Ресторан",
    "city": "Город",

    "position": "Должность",
    "citizenship": "Гражданство",
    "about": "Немного о себе",

    "personalData": "Согласие о данных",
    "isAdult": "Возрастной ценз",
  }

  const citizenshipOptions = [
    { value: 'Гражданин РФ', label: 'Гражданин РФ' },
    { value: 'Иностранный гражданин', label: 'Иностранный гражданин' }
  ];

  function applicationOk(res) {
    setApplicationState({ showingModal: true, result: res });
  }
  function applicationError(err) {
    setApplicationState({ showingModal: true, error: err });
  }

  const fetchAndSetProfessionsList = useCallback( async () => {
    return getProfessionsList()
      .then((content) => { //content это ['Официант', 'Бармен', ...]
        setProfOpts(content.map(nameProfession => 
          ({value: nameProfession, label: nameProfession}))); 
      }).catch((e) => {
        console.error(e);
      });
  }, []);

  const fetchAndSetJobApplication = useCallback( async (body) => {
    return createJobApplication(body)
      .then((content) => {
        applicationOk(content);
      }).catch((e) => {
        applicationError(e);
      }).finally(() => {
        setApplicationState(prev => ({...prev, pending: false}));
      })
  }, []);

  useEffect(() => { 
    fetchAndSetProfessionsList();
  }, []);


  function submitJobApplication(antdFormValues) { //submitApplication
    //валидация внутри разметки Antd Form
    const selectedCity = antdFormValues?.city;
    const selectedCitizenship = antdFormValues?.citizenship;
    const selectedPlaceByCity = places?.find(place => place?.city === selectedCity);
    const fallbackPlace = places?.[current] || places?.[0];
    const placeForCareer = selectedPlaceByCity || fallbackPlace;
    const aboutWithCitizenship = [
      antdFormValues?.about,
      selectedCitizenship ? `Гражданство: ${selectedCitizenship}` : undefined,
    ].filter(Boolean).join('\n');

    const oldCareerContractBody = {
      last_name: antdFormValues?.last_name,
      first_name: antdFormValues?.first_name,
      middle_name: antdFormValues?.middle_name,
      phone: antdFormValues?.phone,
      rest_id: placeForCareer?.id,
      position: antdFormValues?.position,
      about: aboutWithCitizenship,
    };

    const body = makeFormData(
      oldCareerContractBody,
      'last_name',
      'first_name',
      'middle_name',
      'phone',
      'rest_id',
      'position',
      'about'
    );

    if (body instanceof Map) {
      applicationError('Некорректно заполненная форма');
      return;
    }

    body.set('city', selectedCity || placeForCareer?.city || '');

    setApplicationState(prev => ({
      ...prev, 
      pending: true, 
      showingModal: true
    }));

    fetchAndSetJobApplication(body);
  }

  const openPersonalModal = (e) => {
    e.preventDefault()
    open();
  }


  return (
    <>
      <div className='jobApplicationForm'>
      <Form
        onFinish={submitJobApplication}
        >
        {width >=769 ? <>
          <Item>
            <Item
              name='last_name'
              label={formConfig['last_name']}
              rules={itemRules}
              style={{ 
                display: 'inline-block', 
                width: `calc(33% - ${getDistance(width, 'last_name')})`,
                marginBottom: '0' 
              }}
            >
              <Input status='' placeholder='Константинов' />
            </Item>
            <Item
              name='first_name'
              label={formConfig['first_name']}
              rules={itemRules}
              style={{ 
                display: 'inline-block', 
                width: `calc(33% - ${getDistance(width, 'first_name')})`,
                marginInlineStart: getMarginInlineStart(width, 'first_name')
              }}
              >
              <Input placeholder='Константин'/>
            </Item>
            <Item 
              name='middle_name'
              label={formConfig['middle_name']}
              rules={itemRules}
              style={{ 
                display: 'inline-block', 
                width: `calc(33% - ${getDistance(width, 'middle_name')})`,
                marginInlineStart: getMarginInlineStart(width, 'first_name')
              }}
            >
              <Input placeholder='Константинович'/>
            </Item>
          </Item>

          <div
            style={{
              display: "flex", flexDirection: "row",
              justifyContent: "flex-start", alignItems: "center"
            }}
          >
            <Item 
              name='phone'
              label={formConfig['phone']}
              rules={itemRules.concat([{
                pattern: /\(\d{3}\)\d{3}-\d{2}-\d{2}/,
                validateTrigger: 'blur',
                message: "Телефон заполнен не до конца",
              }])}
              style={{
                width: width > 1025 ? '50%' : `calc(55.5% - ${getDistance(width, 'phone')})`
              }} 
              >
                <MaskedInput
                  defaultValue=''
                  mask={[
                    {mask: '{+7}[(]000[)]000[-]00[-]00'},
                    {mask: '{8}[(]000[)]000[-]00[-]00'},
                  ]}
                  placeholder='+7'
                />
              </Item>
            <Item 
              // name='rest_id'
              // label={formConfig['rest_id']}

              name='city' //newCity
              label={formConfig['city']}
              rules={itemRules}
              style={{
                width: width > 1025 ? '50%' : `calc(44.5% - ${getDistance(width, 'city')})`,
                marginLeft: `${
                  width > 2001 ? '26px' 
                  : (width > 1441) ? '26px' 
                  : (width > 1025) ? '26px' : '10px'}`
              }}
            >
                <Select
                  // options={addressOptions}
                  options={citiesOptions}
                  placeholder='Санкт-Петербург'

                  suffixIcon={<div className='arrow-down-svg'><ArrowDownSvg /></div>}
                  placement='bottomLeft'
                  popupMatchSelectWidth={true}
                />
            </Item>
          </div>

          <div
            style={{
              display: "flex", flexDirection: "row",
              justifyContent: "flex-start", alignItems: "center"
            }}
          >
            <Item
              name='position'
              label={formConfig['position']}
              rules={itemRules}
              style={
                {
                  width: width > 1025 ? '50%' : `calc(55.5% - ${getDistance(width, 'position')})`,
                  position: 'relative',
                }
              }
            >
              <Select
                options={profOpts}
                suffixIcon={<div className='arrow-down-svg'><ArrowDownSvg /></div>}
                placement='bottomLeft'
                popupClassName='heal-select-dropdown'
                popupMatchSelectWidth={true}
                placeholder='Бармен'
              />
            </Item>
            <Item
              name='citizenship'
              label={formConfig['citizenship']}
              rules={itemRules}
              style={{
                width: width > 1025 ? '50%' : `calc(44.5% - ${getDistance(width, 'citizenship')})`,
                marginLeft: `${
                  width > 2001 ? '26px'
                  : (width > 1441) ? '26px'
                  : (width > 1025) ? '26px' : '10px'}`
              }}
            >
              <Select
                options={citizenshipOptions}
                placeholder='Гражданин РФ'
                suffixIcon={<div className='arrow-down-svg'><ArrowDownSvg /></div>}
                placement='bottomLeft'
                popupMatchSelectWidth={true}
              />
            </Item>
          </div>
        </>
        : <>
          <Item>
            <Item
              name='last_name'
              label={formConfig['last_name']}
              rules={itemRules}
              style={{ 
                  display: width > 448 ? 'inline-block' : 'block', 
                  width: width > 448 ? 'calc(50% - 9px)' : '100%', 
                  marginBottom: '0' 
                }}
              >
              <Input status='' placeholder='Константинов'/>
            </Item>

            <Item
              name='first_name'
              label={formConfig['first_name']}
              rules={itemRules}
              style={{ 
                display: width > 448 ? 'inline-block' : 'block', 
                width: width > 448 ? 'calc(50% - 9px)' : '100%', 
                marginInlineStart: width > 448 ? 16 : 0,
                marginTop: width > 448 ? 0 : 21
              }}
              >
              <Input placeholder='Константин'/>
            </Item>
          </Item>

          <Item>
            <Item 
              name='middle_name'
              label={formConfig['middle_name']}
              rules={itemRules}
              style={{ 
                display: width > 448 ? 'inline-block' : 'block', 
                width: width > 448 ? 'calc(50% - 9px)' : '100%', 
              }}
            >
              <Input placeholder='Константинович'/>
            </Item>

            <Item
              label={formConfig['phone']}
              name='phone'
              rules={itemRules.concat([{
                pattern: /\(\d{3}\)\d{3}-\d{2}-\d{2}/,
                validateTrigger: 'blur',
                message: "Телефон заполнен не до конца",
              }])}
              style={{
                display: width > 448 ? 'inline-block' : 'block', 
                width: width > 448 ? 'calc(50% - 9px)' : '100%', 
                marginInlineStart: width > 448 ? 16 : 0,
                marginTop: width > 448 ? 0 : 21
              }}
            >
              <MaskedInput
                defaultValue=''
                mask={[
                  {mask: '{+7}[(]000[)]000[-]00[-]00'},
                  {mask: '{8}[(]000[)]000[-]00[-]00'},
                ]}
                placeholder='+7'
              />
            </Item>
          </Item>

          <Item>
            <Item
              // name='rest_id'
              // label={formConfig['rest_id']}

              name='city' //newCity
              label={formConfig['city']}
              rules={itemRules}
              style={{
                  display: width > 448 ? 'inline-block' : 'block',
                  width: width > 448 ? 'calc(50% - 9px)' : '100%',
                  paddingInline: 0,
                }}
              >
                <Select
                  // options={addressOptions}
                  options={citiesOptions}
                  placeholder='Санкт-Петербург'

                  suffixIcon={<div className='arrow-down-svg'><ArrowDownSvg /></div>}
                  placement='bottomLeft'
                  popupMatchSelectWidth={true}
                  dropdownStyle={{
                    maxWidth: width > 448 ? 'calc(50% - 32px - 9px)' : 'calc(100% - 32px)',
                  }}
                />
            </Item>

            <Item
              name='position'
              label={formConfig['position']}
              rules={itemRules}
              style={{
                display: width > 448 ? 'inline-block' : 'block',
                width: width > 448 ? 'calc(50% - 9px)' : '100%',
                marginInlineStart: width > 448 ? 16 : 0,
                marginTop: width > 448 ? 0 : 21,
                position: 'relative',
              }}
            >
              <Select
                options={profOpts}
                suffixIcon={<div className='arrow-down-svg'><ArrowDownSvg /></div>}
                placement='bottomLeft'
                popupMatchSelectWidth={true}
                popupClassName='heal-select-dropdown'
                dropdownStyle={{
                  maxWidth: width > 448 ? 'calc(50% - 32px - 9px)' : 'calc(100% - 32px)',
                }}
                placeholder='Бармен'
              />
            </Item>
          </Item>

          <Item>
            <Item
              name='citizenship'
              label={formConfig['citizenship']}
              rules={itemRules}
              style={{
                display: width > 448 ? 'inline-block' : 'block',
                width: width > 448 ? 'calc(50% - 9px)' : '100%',
              }}
            >
              <Select
                options={citizenshipOptions}
                placeholder='Гражданин РФ'
                suffixIcon={<div className='arrow-down-svg'><ArrowDownSvg /></div>}
                placement='bottomLeft'
                popupMatchSelectWidth={true}
                dropdownStyle={{
                  maxWidth: width > 448 ? 'calc(50% - 32px - 9px)' : 'calc(100% - 32px)',
                }}
              />
            </Item>
          </Item>

        </>}

        <Item
          required={false}
          name='about'
          label={formConfig['about']}
          rules={itemRules}
          style={{
            display: 'inline-block',
            width: `${width > 769 ? 'calc(50% - 9px)' : '100%'}}`,
          }}
        >
          <TextArea
              placeholder='Ваш текст'
              autoSize={{
                minRows: 4,
                maxRows: 8
              }}
          />
        </Item>

        <Item 
          name='personalData' 
          valuePropName='checked'
          rules={[{
            validator: (_, value) => value 
              ? Promise.resolve()
              : Promise.reject('Подтвердите согласие на обработку персональных данных')
          }]}
        >
          <Checkbox>
            <a href="#" onClick={openPersonalModal}>Согласием на обработку персональных данных</a>
          </Checkbox>
        </Item>

        <Item 
          name='isAdult' 
          valuePropName='checked'
          rules={[{
            validator: (_, value) => value 
              ? Promise.resolve()
              : Promise.reject('Подтвердите, что вам исполнилось 18')
          }]}
        >
          <Checkbox>Мне 18 лет</Checkbox>
        </Item>

        <Button htmlType='submit'>Отправить</Button>

      </Form>
      </div>
      <FormFinishModal 
        applicationState={applicationState}
        setApplicationState={setApplicationState}
      />
      <PersonalDataModal
        {...personalDataModal} close={close}
      />
    </>
  )
}

export default JobApplicationForm;
